module.exports = __webpack_public_path__ + "img/ic_icon_cvu_bank.c9aff030.png";